<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";

   export default {
      page: {
         title: "Lead Vehicles",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },

      data() {

         const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')

         return {
            title: "Lead Vehicles",
            items: [
               {
                  text: "Leads",
                  href: "/leads",
               }, 
               {
                  text: "Vehicles",
                  active: true,
               },                    
            ],

            contact_id: null,
            vehicles: [],
            contact_state: 1,
            base_route: "leads",

            followup: {
               contact_vehicle_id: '',
               service_id: '',
               next_followup: '',
               subreason_id: '',
               is_contact: 0,
               name: '',
               country_code: 1,
               mobile: '',
            },

            followups: {},

            services: [],

            reasons: [],
            subreasons: [],

            reason_id: '',
            reason: '',

            follow_up_date: today_str,
            min_date: today_str,

            token: '',
            errors: {},

            loading: false,

         };
      }, 

      mounted() {
         this.contact_id = this.$route.params.id;
         this.fetchVehicles();

         this.fetchServices();
         this.fetchReasons();
         this.fetchCountries();
      },  

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         },

         alphaDotSpacesOnly(event) {
         let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32) || (keyCode == 46))  {
                  return;
            } else {
               event.preventDefault();
            }
         },

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         fetchVehicles() {
            let url = "/api/hub/contacts/vehicles?id=" + this.$route.params.id;
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.vehicles = responseData.vehicles;
               })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         }, 

         getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },     

         fetchServices() {
            let url = "/api/hub/contacts/services";         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  //console.log(res);
                  var responseData = res.data.data;
                  this.services = responseData.services;
            })
            .catch((err) => console.log(err));
         },  

         fetchReasons() {
            let url = "/api/hub/followups/reasons";         
            this.getToken();
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
                  //console.log(res);
                  var responseData = res.data.data;
                  this.reasons = responseData.reasons;
            })
            .catch((err) => console.log(err));
         }, 

         fetchSubReasons() {
            if(this.reason_id == 2 || this.reason_id == 3) {
               let url = "/api/hub/followups/subreasons?reason_id=" + this.reason_id;         
               this.getToken();
               this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                     //console.log(res);
                     var responseData = res.data.data;
                     this.subreasons = responseData.subreasons;
               })
               .catch((err) => console.log(err));
            }
         }, 

         fetchCountries() {
            let url = "/api/hub/contacts/countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         fetchFollowUps() {
            
            let url = "/api/hub/contacts/get-vehicle-followups?contact_vehicle_id=" + this.followup.contact_vehicle_id;
            
            this.getToken();

            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  //console.log(responseData);
                  this.followups = responseData.followups;
               
               })
            .catch((err) => console.log(err));
         },

         changeFollowUp(followup) {
            this.followup.contact_vehicle_id = followup.id;

            this.fetchFollowUps();

            this.showModal("followup-modal");
         },

         updateFollowUp() {
            this.getToken();
            
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            var data;
            data = JSON.stringify({
               "contact_vehicle_id": this.followup.contact_vehicle_id,
               "service_id": this.followup.service_id,
               "next_followup": this.followup.next_followup,               
            });

            this.loading = true;            
            this.errors = {};
            let url;

            if(this.reason_id == 1) { // change follow up date
               data = JSON.stringify({
                  "contact_vehicle_id": this.followup.contact_vehicle_id,
                  "service_id": this.followup.service_id,
                  "next_followup": this.followup.next_followup,   
                  "remarks": this.followup.remarks,
               });
               url = "/api/hub/followup/changeFollowup";

            } else if(this.reason_id == 2) { // close lead
               data = JSON.stringify({
                  "contact_vehicle_id": this.followup.contact_vehicle_id,
                  "service_id": this.followup.service_id,
                  "subreason_id": this.followup.subreason_id,   
                  "remarks": this.followup.remarks,
               });
               url = "/api/hub/followup/closeFollowup";

            } else if(this.reason_id == 3) { // sold or theft
               data = JSON.stringify({
                  "contact_vehicle_id": this.followup.contact_vehicle_id,
                  "service_id": this.followup.service_id,
                  "subreason_id": this.followup.subreason_id,  
                  "is_contact": this.followup.is_contact,    
                  "name": this.followup.name,
                  "country_code": this.followup.country_code,
                  "mobile": this.followup.mobile,
                  "remarks": this.followup.remarks,
               });
               url = "/api/hub/followup/soldOrTheft";

            } else if(this.reason_id == 4) { // switch off or unavailable
               data = JSON.stringify({
                  "contact_vehicle_id": this.followup.contact_vehicle_id,
                  "service_id": this.followup.service_id,
                  "remarks": this.followup.remarks,
               });
               url = "/api/hub/followup/switchOff";
            }


            this.$axios
               .post(url, data, config)
               .then((response) => {
                  //console.log(response);
                  if (response.data.status) {                    
                     
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.hideModal("followup-modal");
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },  

         clearForm() {           
           
            this.followup.contact_vehicle_id = '';
            this.followup.service_id = '';  
            this.followup.next_followup = '';
            this.followup.subreason_id = '';
            this.followup.is_contact = 0;
            this.followup.name = '';
            this.followup.country_code = 1;
            this.followup.mobile = '';
            this.followup.remarks = '';

            this.reason_id = '';
            this.errors = {};
            this.followups = {};
            this.subreasons = [];
         },
      }   
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <!-- <router-link :to="{ name: 'leads', params: {id: contact_id} }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link> -->
                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>

                        <router-link :to="{ name: 'leads.vehicles.add', params: {id: contact_id}  }" class="btn btn-primary float-end me-2">Add Vehicle</router-link>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>SI. No.</th>
                              <th>Vehicle No.</th>
                              <th>Brand & Model</th>                              
                              <th>Expiry/ Renewal Dates</th>
                              <th>Status</th>
                              <th>Created On</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(vehicles.length)">
                           <tr v-for="(vehicle, index) in vehicles" :key="vehicle.id">
                              <td>{{index + 1}}</td>
                              <td>{{vehicle.vehicle_number}}</td>
                              <td>
                                 {{vehicle.brand}}
                                 <span v-if="vehicle.brand && vehicle.model">,</span><br> 
                                 {{vehicle.model}}
                              </td>
                              
                              <td>
                                 
                                 <table class="table table-nested-flex" style="width:230px;">
                                    <tbody>
                                       <tr v-if="vehicle.insurance_expiry">
                                          <td>Insurance</td>
                                          <td> : </td>
                                          <td>{{vehicle.converted_insurance_expiry}}</td>
                                       </tr>
                                       <tr v-if="vehicle.fitness_expiry">
                                          <td>Fitness</td>
                                          <td> : </td>
                                          <td>{{vehicle.converted_fitness_expiry}}</td>
                                       </tr>
                                       <tr v-if="vehicle.tax_expiry">
                                          <td>Tax</td>
                                          <td> : </td>
                                          <td>{{vehicle.converted_tax_expiry}}</td>
                                       </tr>
                                       <tr v-if="vehicle.permit_expiry">
                                          <td>Permit</td>
                                          <td> : </td>
                                          <td>{{vehicle.converted_permit_expiry}}</td>
                                       </tr>
                                       <tr v-if="vehicle.welfare_fund_renewal">
                                          <td>Welfare Fund</td>
                                          <td> : </td>
                                          <td>{{vehicle.converted_welfare_fund_renewal}}</td>
                                       </tr>
                                       <tr v-if="vehicle.registration_renewal">
                                          <td>Registration</td>
                                          <td> : </td>
                                          <td>{{vehicle.converted_registration_renewal}}</td>
                                       </tr>
                                    </tbody>
                                 </table>                                    
                                    
                                 
                              </td>
                              <td>{{vehicle.converted_vehicle_status}}</td>
                              <td><p class="datetime">{{vehicle.converted_created_at}}</p></td>
                              <td>
                                 <router-link :to="{ name: base_route + '.vehicles.details', params: { contact_id: contact_id, vehicle_id: vehicle.id } }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>

                                 <router-link v-if="vehicle.vehicle_status==1" :to="{ name: base_route + '.vehicles.edit', params: { contact_id: contact_id, vehicle_id: vehicle.id } }" class="btn btn-primary me-2 mb-2 btn-sm">Edit</router-link>
                                 
                                 <button v-if="vehicle.vehicle_status==1" class="btn btn-success btn-sm me-2 mb-2" type="button" @click="changeFollowUp(vehicle)">Change Follow Up</button>    

                              </td>
                           </tr>
                                
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="8" class="text-center">No vehicles found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!---- modal starts ---->
                  <b-modal ref="followup-modal" id="followup-modal" title="Change Follow Up" hide-footer @hidden="clearForm()">  
                     <div class="table-responsive">  
                        <h6>Current Follow Ups:</h6>  
                        <table class="table table-bordered">
                           <tbody>
                              <tr>
                                 <th>Insurance</th>
                                 <td>{{followups.converted_insurance_followup}}</td>
                              </tr>
                              <tr>
                                 <th>Fitness</th>
                                 <td>{{followups.converted_fitness_followup}}</td>
                              </tr>
                              <tr>
                                 <th>Tax</th>
                                 <td>{{followups.converted_tax_followup}}</td>
                              </tr>
                              <tr>
                                 <th>Permit</th>
                                 <td>{{followups.converted_permit_followup}}</td>
                              </tr>
                              <tr>
                                 <th>Welfare Fund</th>
                                 <td>{{followups.converted_insurance_followup}}</td>
                              </tr>
                              <tr>
                                 <th>Registration</th>
                                 <td>{{followups.converted_insurance_followup}}</td>
                              </tr>
                           </tbody>
                        </table>               
                     </div>

                     <b-form @submit.prevent="updateFollowUp()">                    
                        <div class="row">
                           
                           <b-form-group class="col-lg-12">
                              <label>Service <span class="text-danger">*</span></label>
                              
                              <select class="form-control" v-model="followup.service_id" v-bind:class="{ 'is-invalid': Boolean(errors.service_id) }">
                                 <option value="">Select Service</option>
                                 <option :value="service.id" v-for="service in services" :key="service.id">{{service.service}}</option>
                              </select>
                              <div v-for="(val, index) in errors.service_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-12">
                              <label>Reason <span class="text-danger">*</span></label>
                              
                              <select class="form-control" v-model="reason_id" v-bind:class="{ 'is-invalid': Boolean(errors.reason_id) }" @change="fetchSubReasons(), followup.subreason_id=''">
                                 <option value="">Select Reason</option>
                                 <option :value="reason.id" v-for="reason in reasons" :key="reason.id">{{reason.reason}}</option>
                              </select>
                              <div v-for="(val, index) in errors.reason_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-12" v-if="reason_id==2 || reason_id==3">
                              <label>Reason <span class="text-danger">*</span></label>
                              
                              <select class="form-control" v-model="followup.subreason_id" v-bind:class="{ 'is-invalid': Boolean(errors.subreason_id) }" >
                                 <option value="">Select Reason</option>
                                 <option :value="subreason.id" v-for="subreason in subreasons" :key="subreason.id">{{subreason.subreason}}</option>
                              </select>
                              <div v-for="(val, index) in errors.subreason_id" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-12" v-if="reason_id==1">
                              <label>Next Follow Up Date <span class="text-danger">*</span></label>
                              <b-form-input type="date" v-model="followup.next_followup" v-bind:class="{ 'is-invalid': Boolean(errors.next_followup) }" ></b-form-input>
                              <div v-for="(val, index) in errors.next_followup" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <div class="col-12" v-if="followup.subreason_id==4">
                              <b-form-group class="col-lg-12">

                                 <b-form-checkbox
                                    v-model="followup.is_contact"
                                    :value="1"
                                    :unchecked-value="0"
                                 >
                                    <span class="ms-2">I have the contact details of the person to whom vehicle is sold</span>
                                 </b-form-checkbox>

                              </b-form-group>
                              <div class="row" v-if="followup.is_contact==1">
                                 <b-form-group class="col-lg-6">
                                    <label>Name <span class="text-danger">*</span></label>
                                    <b-form-input v-model="followup.name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }" maxlength="100"  @keypress="alphaDotSpacesOnly"></b-form-input>

                                    <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>
                                 <div class="col-lg-6">
                                    <b-form-group>
                                       <label>Mobile <span class="text-danger">*</span></label>
                                       <b-input-group>
                                          <b-input-group-prepend>
                                             <select class="form-control" v-model="followup.country_code">
                                                <option :value="country.id" v-for="country in countries" :key="country.id">{{country.code}}</option>
                                             </select>
                                          </b-input-group-prepend>

                                          <b-form-input v-model="followup.mobile" maxlength="10" @keypress="numbersOnly"  v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                       </b-input-group>

                                       <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback" style="display: block;">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </b-form-group>
                                 </div>

                              </div>
                           </div>

                           <b-form-group class="col-lg-12">
                              <label>Remarks</label>
                              <b-form-textarea v-model="followup.remarks" v-bind:class="{ 'is-invalid': Boolean(errors.remarks) }" ></b-form-textarea>

                              <div v-for="(val, index) in errors.remarks" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary">Update</b-button>
                              <b-button class="" variant="light" @click="hideModal('followup-modal')">Cancel</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                     
                  </b-modal>
                  <!---- modal ends ----->  

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
